import API from "@unisearch/helpers/api";
import { useRouter } from "next/router";
import { MdOutlineQuestionAnswer } from "react-icons/md";
import styles from "./actions.module.scss";

export const ChatAction = ({ recieverType, uniId, ...props }) => {
  const router = useRouter();

  const connectChat = async (uniId) => {
    await API.post("/chat-service/add-user", {
      recieverId: parseInt(uniId),
      recieverType: recieverType ?? "university",
      senderTime: new Date(),
    }).then(async (res) => {
      if (!res.error) {
        router.push(`/app/student/messages?chatId=${res.data?.uid}`);
      }
    });
  };

  const renderComponent = () => {
    return (
      <div className={`${styles.connect_wrapper}  relative`}>
        <MdOutlineQuestionAnswer
          onClick={() => {
            connectChat(uniId);
          }}
        />
        <div className={`uni-tooltip`}>Chat</div>
      </div>
    );
  };

  if (typeof window !== "undefined") {
    return renderComponent();
  } else {
    return false;
  }
};

export default ChatAction;
